import { BASE_URL } from '../../../Constant';

export const API_GET_ALL_DOCUMENT_DRAFTS: string = `${BASE_URL}/document/drafts`;
